import React from 'react';
import { TrendingUp, ArrowUpRight } from 'lucide-react';
import { TYPE } from '../../constants/typeScale';

interface PromoSpec {
  url: string;
  title: string;
  body: string;
  cta?: string;
}

/**
 * A soft, non-intrusive cross-promo card (e.g. IndexAlpha for equity/portfolio research).
 * Rendered in the chat stream from a `{ type:'Promo', … }` spec — a gentle nudge at the
 * right moment, clearly a Wisetree suggestion, not an agent's words. Opens in a new tab.
 */
const PromoCard: React.FC<{ spec: PromoSpec }> = ({ spec }) => (
  <a
    href={spec.url}
    target="_blank"
    rel="noreferrer"
    data-testid="promo-card"
    className="group inline-flex max-w-sm items-start gap-3 rounded-xl border border-secondary-200 dark:border-secondary-600 bg-secondary-50/70 dark:bg-secondary-900/60 p-3 hover:border-secondary-400 transition-colors"
  >
    <span className="mt-0.5 shrink-0 inline-flex h-7 w-7 items-center justify-center rounded-full bg-secondary-200 dark:bg-secondary-800">
      <TrendingUp className="h-4 w-4 text-secondary-600 dark:text-secondary-300" />
    </span>
    <span className="min-w-0">
      <span className={`block ${TYPE.control} font-medium text-secondary-900 dark:text-white`}>{spec.title}</span>
      <span className={`block ${TYPE.meta} text-secondary-500 dark:text-secondary-400`}>{spec.body}</span>
      <span className={`mt-1 inline-flex items-center gap-1 ${TYPE.control} font-medium text-secondary-700 dark:text-secondary-200 group-hover:underline`}>
        {spec.cta || 'Learn more'} <ArrowUpRight className="h-3 w-3" />
      </span>
    </span>
  </a>
);

export default PromoCard;
